import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => (
  <div className="relative bg-gradient-to-r from-slate-800 to-slate-900 dark:from-slate-900 dark:to-black text-white py-16">
    {/* Professional Trust Badges */}
    <div className="absolute top-4 right-4 md:top-6 md:right-8 lg:right-16">
      <div className="bg-white dark:bg-gray-800 rounded-full px-3 py-1.5 md:px-4 md:py-2 flex items-center gap-2 border border-gray-200 dark:border-gray-700">
        <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
        <span className="text-slate-800 dark:text-gray-200 font-medium text-xs md:text-sm">
          2,500+ Companies Served
        </span>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Column - Content */}
        <div className="space-y-8">
          <div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Discover How Much</h1>
            <h1 className="text-5xl md:text-6xl font-bold text-emerald-400 dark:text-emerald-300 mb-6">
              You Could Save
            </h1>
            <h1 className="text-5xl md:text-6xl font-bold mb-8">Today</h1>
          </div>

          <p className="text-lg text-gray-300 dark:text-gray-400 max-w-lg leading-relaxed">
            With Australian energy costs rising 23% in 2024, identify hidden savings before your
            next bill. Get a free Energy Savings Assessment and unlock detailed insights when
            you're ready.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/assessment/self-guided"
              className="bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-700 dark:hover:bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
            >
              <span className="flex flex-col items-start">
                <span className="text-sm opacity-90">Book a Consultant Session</span>
                <span>Professional Energy Assessment</span>
              </span>
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3a2 2 0 012-2h4a2 2 0 012 2v4m-6 9v6a2 2 0 002 2h8a2 2 0 002-2v-6M8 7h8v10H8V7z"
                />
              </svg>
            </Link>
            <Link
              to="/sample-esa-report"
              className="border-2 border-emerald-400 dark:border-emerald-500 text-emerald-400 dark:text-emerald-300 hover:bg-emerald-400 hover:text-slate-900 dark:hover:bg-emerald-500 dark:hover:text-white px-8 py-4 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
            >
              <span className="flex flex-col items-start">
                <span className="text-sm opacity-75">Professional Analysis Engine</span>
                <span>View Sample Report</span>
              </span>
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </Link>
          </div>
        </div>

        {/* Right Column - Statistics Panel */}
        <div className="lg:justify-self-end">
          <div className="bg-slate-700/50 dark:bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-600 dark:border-slate-700">
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold text-emerald-400 dark:text-emerald-300 mb-2">
                  $128K
                </div>
                <div className="text-gray-300 dark:text-gray-400 text-sm">
                  Average Annual Cost Savings
                </div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-emerald-400 dark:text-emerald-300 mb-2">
                  18 m
                </div>
                <div className="text-gray-300 dark:text-gray-400 text-sm">Typical Payback Period</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-emerald-400 dark:text-emerald-300 mb-2">
                  25%
                </div>
                <div className="text-gray-300 dark:text-gray-400 text-sm">Energy Cost Reduction</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-emerald-400 dark:text-emerald-300 mb-2">
                  15 min
                </div>
                <div className="text-gray-300 dark:text-gray-400 text-sm">Assessment Time</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HeroSection;


